import React from 'react';
import styles from './SidebarBack.module.scss';
import ArrowIcon from '../common/assets/back-arrow.svg';
import useGoBackOrGoHome from '../Routes/redirects/useGoBackOrGoHome';
import { getTranslation } from '../localizations/translations';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';

type Props = {
  id: string;
  closeSidebar: () => void;
};

export const SidebarBack: React.FC<Props> = ({ id, closeSidebar }) => {
  const goBackOrGoHome = useGoBackOrGoHome();
  const { languageCode } = useAppFeaturesContext();

  return (
    <button
      className={styles.sidebarBack}
      onClick={() => {
        closeSidebar();
        goBackOrGoHome();
      }}
      id={id}
      data-testid="sidebar-back"
      aria-label={getTranslation('common_back', languageCode)}
    >
      <ArrowIcon />
    </button>
  );
};
